// extracted by mini-css-extract-plugin
export default {"buttonDelete":"modalsCategory_buttonDelete__1FCg7","form":"modalsCategory_form__EansF","list":"modalsCategory_list__ZZ-28"};